import getUpcomingEscapePrimaryBooking from './getUpcomingEscapePrimaryBooking'

/**
 * Sync booking title for Upcoming Escape. Uses the same product-line fallback as
 * countdown and date range so the heading cannot describe a different booking.
 */
function getUpcomingEscapeBookingTitle(
  order: App.Order,
  offer: App.Offer | App.BedbankOffer | undefined,
  formatFlightRoute: (departureAirport: string, arrivalAirport: string) => string,
): string | undefined {
  const primary = getUpcomingEscapePrimaryBooking(order)
  const { kind } = primary

  if (kind === 'stay') {
    const offerName = offer?.property?.name || offer?.name
    if (primary.stayOfferId || primary.startDate) {
      return offerName || primary.stayName
    }
    return offerName
      || order.items.find(item => item.status !== 'cancelled')?.offer?.property?.name
      || order.items.find(item => item.status !== 'cancelled')?.offer?.name
      || order.bedbankItems.find(item => item.status !== 'cancelled')?.offer?.name
  }

  if (kind === 'tour') {
    return order.tourItems.find(item => item.status !== 'cancelled')?.tour?.title
  }

  if (kind === 'cruise') {
    return order.cruiseItems.find(item => item.status !== 'cancelled')?.offerName
  }

  if (kind === 'flight') {
    const flightItem = order.flightItems.find(item => item.status !== 'cancelled')
    if (flightItem?.departingAirport && flightItem?.arrivalAirport) {
      return formatFlightRoute(flightItem.departingAirport, flightItem.arrivalAirport)
    }
    return undefined
  }

  return order.experienceItems.find(item => item.status !== 'cancelled')?.title
}

export default getUpcomingEscapeBookingTitle
